import { forwardRef } from "react";
import { cn } from "@/lib/utils";
import { ArrowRight } from "lucide-react";

const base =
  "inline-flex items-center justify-center gap-2 font-medium rounded-full transition-[background-color,transform,box-shadow,color] duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-offset-2 disabled:opacity-60 disabled:pointer-events-none will-change-transform";

const sizes = {
  md: "px-6 py-3 text-sm",
  lg: "px-8 py-4 text-base",
};

const variants = {
  amber: "bg-amber-600 text-white hover:bg-amber-700 hover:-translate-y-0.5 shadow-[0_10px_30px_-12px_rgba(217,119,6,0.7)]",
  navy: "bg-navy text-white hover:bg-navy-light hover:-translate-y-0.5",
  outline: "border border-navy/20 text-navy hover:border-navy hover:-translate-y-0.5 bg-transparent",
  ghostLight: "border border-white/25 text-white hover:bg-white/10 hover:-translate-y-0.5",
};

export const CTAButton = forwardRef(
  ({ className, variant = "amber", size = "md", withArrow = false, children, ...props }, ref) => (
    <button
      ref={ref}
      className={cn(base, sizes[size], variants[variant], "group", className)}
      {...props}
    >
      {children}
      {withArrow && (
        <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
      )}
    </button>
  )
);
CTAButton.displayName = "CTAButton";
